var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-flex justify-content-center mt-2"},[_c('b-spinner',{attrs:{"label":"Загрузка"}}),_c('strong',{staticClass:"pt-1 pl-2"},[_vm._v("Загрузка...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }